// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/elevation.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/remove.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/elevation-pushpin.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/elevation-position.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/elevation-lime.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/elevation-steelblue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/elevation-purple.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidden {
  visibility: hidden;
}

.legend {
  cursor: pointer;
}

.leaflet-container {
  z-index: 0;
  /* prevent overlapping the .elevation-detached chart */
}

.elevation-detached {
  font: 12px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
  height: auto;
  width: 100%;
  position: relative;
  z-index: 0;
}

.elevation-detached .elevation {
  width: 100%;
}

.elevation-detached .background {
  max-width: 100%;
}

.elevation-control.elevation .background {
  background-color: rgba(70, 130, 180, 0.2);
  border-radius: 5px;
  overflow: visible;
  display: block;
  touch-action: none;
}

.elevation-control.elevation .axis line,
.elevation-control.elevation .axis path {
  stroke: #2D1130;
  stroke-width: 1;
  fill: none;
}

.elevation-control.elevation .grid .tick line {
  stroke: #EEE;
  stroke-width: 1px;
  shape-rendering: crispEdges;
}

.elevation-control.elevation .grid path {
  stroke-width: 0;
  pointer-events: none;
}

.elevation-control.elevation .axis text {
  text-anchor: end;
  fill: #000;
  font-weight: 700;
}

.elevation-control.elevation .area {
  fill: #4682B4;
  stroke: #000;
  stroke-width: 1.8;
  paint-order: stroke fill;
}

.elevation-control.elevation .horizontal-drag-line {
  stroke: transparent;
  cursor: row-resize;
  stroke-width: 1.1;
  stroke-dasharray: 5;
}

.elevation-control.elevation .active .horizontal-drag-line {
  stroke: #000;
}

.elevation-control.elevation .horizontal-drag-label {
  font-weight: 700;
  fill: #000;
  paint-order: stroke;
  stroke: #FFF;
  stroke-width: 2px;
  pointer-events: none;
}

.elevation-control.elevation .horizontal-drag-group {
  cursor: row-resize;
  color: #000;
}

.elevation-control.elevation .mouse-focus-line {
  stroke: #0D1821;
  stroke-width: 1;
  pointer-events: none;
}

.elevation-control.elevation .mouse-focus-label-rect {
  fill: #000;
  fill-opacity: 0.75;
  pointer-events: none;
  stroke-width: 1;
  stroke: #444;
}

.elevation-control.elevation .mouse-focus-label-text {
  fill: #FFF;
  pointer-events: none;
  font-size: 10px;
}

.elevation-control.elevation .mouse-drag {
  fill: rgba(23, 74, 117, 0.4);
}

.elevation-control.elevation .elevation-toggle {
  cursor: pointer;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  width: 36px;
  height: 36px;
  background-color: #F8F8F9;
}

.elevation-summary {
  font-family: "Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif;
  font-size: 12px;
  margin: 0 auto;
}

.leaflet-control-container .elevation-summary {
  text-shadow:
    1.5px 0 0 #FFF,
    -1.5px 0 0 #FFF,
    0 1.5px 0 #FFF,
    0 -1.5px 0 #FFF,
    1px 1px #FFF,
    -1px -1px 0 #FFF,
    1px -1px 0 #FFF,
    -1px 1px 0 #FFF;
}

.elevation-detached .elevation-summary {
  margin: 0 45px;
}

.elevation-summary.multiline-summary {
  margin-right: 30px;
}

.elevation-detached .elevation-summary.multiline-summary {
  margin-bottom: 12px;
  margin-top: 12px;
  line-height: 2;
}

.elevation-summary.inline-summary>span:not(:last-child):after {
  content: "\\0020\\2014\\0020";
}

.elevation-summary.multiline-summary>span {
  display: block;
}

.elevation-summary.multiline-summary .download {
  float: right;
  margin-top: -2.5em;
  font-weight: bold;
  font-size: 1.2em;
}

.elevation-detached .elevation-summary.multiline-summary .download {
  margin-top: -3.5em;
}

.elevation-summary .summaryvalue {
  font-weight: bold;
}

.elevation-control.elevation-collapsed .background,
.elevation-control.elevation-collapsed .elevation-summary {
  display: none;
}

.elevation-control.elevation-collapsed .elevation-toggle {
  display: block;
}

.elevation-control.elevation .elevation-toggle-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
}

.elevation-control.elevation.elevation-expanded .elevation-toggle-icon.close-button {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
  position: absolute;
  right: 5px;
  top: 5px;
  height: 20px;
  width: 20px;
}

.leaflet-elevation-pane .height-focus,
.leaflet-overlay-pane .height-focus {
  stroke: #000;
  fill: #FFF;
}

.leaflet-elevation-pane .height-focus.line,
.leaflet-overlay-pane .height-focus.line {
  pointer-events: none;
  stroke-width: 2;
}

.leaflet-elevation-pane .height-focus-label,
.leaflet-overlay-pane .height-focus-label {
  font-size: 12px;
  font-weight: 600;
  fill: #000;
  paint-order: stroke;
  stroke: #FFF;
  stroke-width: 2px;
}

.elevation-waypoint-icon:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center / contain;
  content: "";
  width: 100%;
  height: 100%;
  display: inline-block;
}

.elevation-position-icon:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center center / contain;
  content: "";
  width: 100%;
  height: 100%;
  display: inline-block;
}

.elevation-polyline {
  filter: drop-shadow(1px 1px 0 #FFF) drop-shadow(-1px -1px 0 #FFF) drop-shadow(1px -1px 0 #FFF) drop-shadow(-1px 1px 0 #FFF);
}

.elevation-placeholder {
  margin: auto;
  height: auto;
  width: 100%;
}

.elevation-placeholder~* {
  display: none !important;
}

/* LIME THEME //////////////////////////////////////////////// */

.lime-theme.elevation-control.elevation .background {
  background-color: rgba(156, 194, 34, 0.2);
}

.lime-theme.elevation-control.elevation .axis line,
.lime-theme.elevation-control.elevation .axis path {
  stroke: #566B13;
}

.lime-theme.elevation-control.elevation .grid .tick line {
  stroke: #CCC;
}

.lime-theme.elevation-control.elevation .mouse-drag {
  fill: rgba(99, 126, 11, 0.4);
}

.lime-theme.elevation-control.elevation .elevation-toggle-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center center;
}

.lime-theme.elevation-control.elevation .area {
  fill: #9CC222;
}

.lime-theme.elevation-control.elevation .mouse-focus-line {
  stroke: #101404;
}

.lime-theme.height-focus {
  stroke: #000;
  fill: #9CC222;
}

.lime-theme.elevation-polyline {
  stroke: #566B13;
}

/* STEELBLUE THEME //////////////////////////////////////////////// */

.steelblue-theme.elevation-control.elevation .background {
  background-color: rgba(70, 130, 180, 0.2);
}

.steelblue-theme.elevation-control.elevation .axis line,
.steelblue-theme.elevation-control.elevation .axis path {
  stroke: #0D1821;
}

.steelblue-theme.elevation-control.elevation .mouse-drag {
  fill: rgba(23, 74, 117, 0.4);
}

.steelblue-theme.elevation-control.elevation .elevation-toggle-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center center;
}

.steelblue-theme.elevation-control.elevation .area {
  fill: #4682B4;
}

.steelblue-theme.elevation-control.elevation .mouse-focus-line {
  stroke: #0D1821;
}

.steelblue-theme.height-focus {
  stroke: #000;
  fill: #4682B4;
}

.steelblue-theme.elevation-polyline {
  stroke: #4682B4;
}

/* PURPLE THEME //////////////////////////////////////////////// */

.purple-theme.elevation-control.elevation .background {
  background-color: rgba(115, 44, 123, 0.2);
}

.purple-theme.elevation-control.elevation .axis line,
.purple-theme.elevation-control.elevation .axis path {
  stroke: #2D1130;
}

.purple-theme.elevation-control.elevation .mouse-drag {
  fill: rgba(74, 14, 80, 0.4);
}

.purple-theme.elevation-control.elevation .elevation-toggle-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center center;
}

.purple-theme.elevation-control.elevation .area {
  fill: #732C7B;
}

.purple-theme.elevation-control.elevation .mouse-focus-line {
  stroke: #000;
}

.purple-theme.height-focus {
  stroke: #000;
  fill: #732C7B;
}

.purple-theme.elevation-polyline {
  stroke: #732C7B;
}

/* YELLOW THEME //////////////////////////////////////////////// */

.yellow-theme.elevation-control.elevation .area {
  fill: #FF0;
}

.yellow-theme.elevation-polyline {
  stroke: #FF0;
}

/* RED THEME //////////////////////////////////////////////// */

.red-theme.elevation-control.elevation .area {
  fill: #F00;
  stroke: #000;
}

.red-theme.elevation-polyline {
  stroke: #F00;
}

/* MAGENTA THEME //////////////////////////////////////////////// */

.magenta-theme.elevation-control.elevation .background {
  background-color: rgba(255, 255, 255, 0.47);
}

.magenta-theme.elevation-control.elevation .area {
  fill: #FF005E;
  stroke: #000;
}

.magenta-theme.elevation-polyline {
  stroke: #FF005E;
}

/* LIGHTBLUE THEME //////////////////////////////////////////////// */

.lightblue-theme.elevation-control.elevation .area {
  fill: #3366CC;
  stroke: #000;
  stroke-width: 1.25;
}

.elevation-detached .lightblue-theme.elevation-control.elevation .area {
  stroke: #3366CC;
  fill-opacity: 0.45;
}

.lightblue-theme.height-focus {
  stroke: #000;
  fill: #FFFFFF;
}

.lightblue-theme.elevation-polyline {
  stroke: #3366CC;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@raruto/leaflet-elevation/dist/leaflet-elevation.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,sDAAsD;AACxD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,0FAA0F;EAC1F,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;;;;;;;;mBAQiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2EAAgE;AAClE;;AAEA;EACE,uFAAyE;EACzE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qFAAkF;EAClF,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qFAAmF;EACnF,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,2HAA2H;AAC7H;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gEAAgE;;AAEhE;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2EAAqE;AACvE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,qEAAqE;;AAErE;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2EAA0E;AAC5E;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,kEAAkE;;AAElE;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2EAAuE;AACzE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,kEAAkE;;AAElE;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA,+DAA+D;;AAE/D;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,mEAAmE;;AAEnE;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,qEAAqE;;AAErE;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".hidden {\r\n  visibility: hidden;\r\n}\r\n\r\n.legend {\r\n  cursor: pointer;\r\n}\r\n\r\n.leaflet-container {\r\n  z-index: 0;\r\n  /* prevent overlapping the .elevation-detached chart */\r\n}\r\n\r\n.elevation-detached {\r\n  font: 12px/1.5 \"Helvetica Neue\", Arial, Helvetica, sans-serif;\r\n  height: auto;\r\n  width: 100%;\r\n  position: relative;\r\n  z-index: 0;\r\n}\r\n\r\n.elevation-detached .elevation {\r\n  width: 100%;\r\n}\r\n\r\n.elevation-detached .background {\r\n  max-width: 100%;\r\n}\r\n\r\n.elevation-control.elevation .background {\r\n  background-color: rgba(70, 130, 180, 0.2);\r\n  border-radius: 5px;\r\n  overflow: visible;\r\n  display: block;\r\n  touch-action: none;\r\n}\r\n\r\n.elevation-control.elevation .axis line,\r\n.elevation-control.elevation .axis path {\r\n  stroke: #2D1130;\r\n  stroke-width: 1;\r\n  fill: none;\r\n}\r\n\r\n.elevation-control.elevation .grid .tick line {\r\n  stroke: #EEE;\r\n  stroke-width: 1px;\r\n  shape-rendering: crispEdges;\r\n}\r\n\r\n.elevation-control.elevation .grid path {\r\n  stroke-width: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n.elevation-control.elevation .axis text {\r\n  text-anchor: end;\r\n  fill: #000;\r\n  font-weight: 700;\r\n}\r\n\r\n.elevation-control.elevation .area {\r\n  fill: #4682B4;\r\n  stroke: #000;\r\n  stroke-width: 1.8;\r\n  paint-order: stroke fill;\r\n}\r\n\r\n.elevation-control.elevation .horizontal-drag-line {\r\n  stroke: transparent;\r\n  cursor: row-resize;\r\n  stroke-width: 1.1;\r\n  stroke-dasharray: 5;\r\n}\r\n\r\n.elevation-control.elevation .active .horizontal-drag-line {\r\n  stroke: #000;\r\n}\r\n\r\n.elevation-control.elevation .horizontal-drag-label {\r\n  font-weight: 700;\r\n  fill: #000;\r\n  paint-order: stroke;\r\n  stroke: #FFF;\r\n  stroke-width: 2px;\r\n  pointer-events: none;\r\n}\r\n\r\n.elevation-control.elevation .horizontal-drag-group {\r\n  cursor: row-resize;\r\n  color: #000;\r\n}\r\n\r\n.elevation-control.elevation .mouse-focus-line {\r\n  stroke: #0D1821;\r\n  stroke-width: 1;\r\n  pointer-events: none;\r\n}\r\n\r\n.elevation-control.elevation .mouse-focus-label-rect {\r\n  fill: #000;\r\n  fill-opacity: 0.75;\r\n  pointer-events: none;\r\n  stroke-width: 1;\r\n  stroke: #444;\r\n}\r\n\r\n.elevation-control.elevation .mouse-focus-label-text {\r\n  fill: #FFF;\r\n  pointer-events: none;\r\n  font-size: 10px;\r\n}\r\n\r\n.elevation-control.elevation .mouse-drag {\r\n  fill: rgba(23, 74, 117, 0.4);\r\n}\r\n\r\n.elevation-control.elevation .elevation-toggle {\r\n  cursor: pointer;\r\n  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);\r\n  border-radius: 5px;\r\n  width: 36px;\r\n  height: 36px;\r\n  background-color: #F8F8F9;\r\n}\r\n\r\n.elevation-summary {\r\n  font-family: \"Lucida Grande\", \"Lucida Sans Unicode\", Verdana, Arial, Helvetica, sans-serif;\r\n  font-size: 12px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.leaflet-control-container .elevation-summary {\r\n  text-shadow:\r\n    1.5px 0 0 #FFF,\r\n    -1.5px 0 0 #FFF,\r\n    0 1.5px 0 #FFF,\r\n    0 -1.5px 0 #FFF,\r\n    1px 1px #FFF,\r\n    -1px -1px 0 #FFF,\r\n    1px -1px 0 #FFF,\r\n    -1px 1px 0 #FFF;\r\n}\r\n\r\n.elevation-detached .elevation-summary {\r\n  margin: 0 45px;\r\n}\r\n\r\n.elevation-summary.multiline-summary {\r\n  margin-right: 30px;\r\n}\r\n\r\n.elevation-detached .elevation-summary.multiline-summary {\r\n  margin-bottom: 12px;\r\n  margin-top: 12px;\r\n  line-height: 2;\r\n}\r\n\r\n.elevation-summary.inline-summary>span:not(:last-child):after {\r\n  content: \"\\0020\\2014\\0020\";\r\n}\r\n\r\n.elevation-summary.multiline-summary>span {\r\n  display: block;\r\n}\r\n\r\n.elevation-summary.multiline-summary .download {\r\n  float: right;\r\n  margin-top: -2.5em;\r\n  font-weight: bold;\r\n  font-size: 1.2em;\r\n}\r\n\r\n.elevation-detached .elevation-summary.multiline-summary .download {\r\n  margin-top: -3.5em;\r\n}\r\n\r\n.elevation-summary .summaryvalue {\r\n  font-weight: bold;\r\n}\r\n\r\n.elevation-control.elevation-collapsed .background,\r\n.elevation-control.elevation-collapsed .elevation-summary {\r\n  display: none;\r\n}\r\n\r\n.elevation-control.elevation-collapsed .elevation-toggle {\r\n  display: block;\r\n}\r\n\r\n.elevation-control.elevation .elevation-toggle-icon {\r\n  background: url(../images/elevation.svg) no-repeat center center;\r\n}\r\n\r\n.elevation-control.elevation.elevation-expanded .elevation-toggle-icon.close-button {\r\n  background: transparent url(../images/remove.svg) no-repeat center center;\r\n  position: absolute;\r\n  right: 5px;\r\n  top: 5px;\r\n  height: 20px;\r\n  width: 20px;\r\n}\r\n\r\n.leaflet-elevation-pane .height-focus,\r\n.leaflet-overlay-pane .height-focus {\r\n  stroke: #000;\r\n  fill: #FFF;\r\n}\r\n\r\n.leaflet-elevation-pane .height-focus.line,\r\n.leaflet-overlay-pane .height-focus.line {\r\n  pointer-events: none;\r\n  stroke-width: 2;\r\n}\r\n\r\n.leaflet-elevation-pane .height-focus-label,\r\n.leaflet-overlay-pane .height-focus-label {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  fill: #000;\r\n  paint-order: stroke;\r\n  stroke: #FFF;\r\n  stroke-width: 2px;\r\n}\r\n\r\n.elevation-waypoint-icon:before {\r\n  background: url(../images/elevation-pushpin.png) no-repeat center center / contain;\r\n  content: \"\";\r\n  width: 100%;\r\n  height: 100%;\r\n  display: inline-block;\r\n}\r\n\r\n.elevation-position-icon:before {\r\n  background: url(../images/elevation-position.png) no-repeat center center / contain;\r\n  content: \"\";\r\n  width: 100%;\r\n  height: 100%;\r\n  display: inline-block;\r\n}\r\n\r\n.elevation-polyline {\r\n  filter: drop-shadow(1px 1px 0 #FFF) drop-shadow(-1px -1px 0 #FFF) drop-shadow(1px -1px 0 #FFF) drop-shadow(-1px 1px 0 #FFF);\r\n}\r\n\r\n.elevation-placeholder {\r\n  margin: auto;\r\n  height: auto;\r\n  width: 100%;\r\n}\r\n\r\n.elevation-placeholder~* {\r\n  display: none !important;\r\n}\r\n\r\n/* LIME THEME //////////////////////////////////////////////// */\r\n\r\n.lime-theme.elevation-control.elevation .background {\r\n  background-color: rgba(156, 194, 34, 0.2);\r\n}\r\n\r\n.lime-theme.elevation-control.elevation .axis line,\r\n.lime-theme.elevation-control.elevation .axis path {\r\n  stroke: #566B13;\r\n}\r\n\r\n.lime-theme.elevation-control.elevation .grid .tick line {\r\n  stroke: #CCC;\r\n}\r\n\r\n.lime-theme.elevation-control.elevation .mouse-drag {\r\n  fill: rgba(99, 126, 11, 0.4);\r\n}\r\n\r\n.lime-theme.elevation-control.elevation .elevation-toggle-icon {\r\n  background: url(../images/elevation-lime.svg) no-repeat center center;\r\n}\r\n\r\n.lime-theme.elevation-control.elevation .area {\r\n  fill: #9CC222;\r\n}\r\n\r\n.lime-theme.elevation-control.elevation .mouse-focus-line {\r\n  stroke: #101404;\r\n}\r\n\r\n.lime-theme.height-focus {\r\n  stroke: #000;\r\n  fill: #9CC222;\r\n}\r\n\r\n.lime-theme.elevation-polyline {\r\n  stroke: #566B13;\r\n}\r\n\r\n/* STEELBLUE THEME //////////////////////////////////////////////// */\r\n\r\n.steelblue-theme.elevation-control.elevation .background {\r\n  background-color: rgba(70, 130, 180, 0.2);\r\n}\r\n\r\n.steelblue-theme.elevation-control.elevation .axis line,\r\n.steelblue-theme.elevation-control.elevation .axis path {\r\n  stroke: #0D1821;\r\n}\r\n\r\n.steelblue-theme.elevation-control.elevation .mouse-drag {\r\n  fill: rgba(23, 74, 117, 0.4);\r\n}\r\n\r\n.steelblue-theme.elevation-control.elevation .elevation-toggle-icon {\r\n  background: url(../images/elevation-steelblue.svg) no-repeat center center;\r\n}\r\n\r\n.steelblue-theme.elevation-control.elevation .area {\r\n  fill: #4682B4;\r\n}\r\n\r\n.steelblue-theme.elevation-control.elevation .mouse-focus-line {\r\n  stroke: #0D1821;\r\n}\r\n\r\n.steelblue-theme.height-focus {\r\n  stroke: #000;\r\n  fill: #4682B4;\r\n}\r\n\r\n.steelblue-theme.elevation-polyline {\r\n  stroke: #4682B4;\r\n}\r\n\r\n/* PURPLE THEME //////////////////////////////////////////////// */\r\n\r\n.purple-theme.elevation-control.elevation .background {\r\n  background-color: rgba(115, 44, 123, 0.2);\r\n}\r\n\r\n.purple-theme.elevation-control.elevation .axis line,\r\n.purple-theme.elevation-control.elevation .axis path {\r\n  stroke: #2D1130;\r\n}\r\n\r\n.purple-theme.elevation-control.elevation .mouse-drag {\r\n  fill: rgba(74, 14, 80, 0.4);\r\n}\r\n\r\n.purple-theme.elevation-control.elevation .elevation-toggle-icon {\r\n  background: url(../images/elevation-purple.svg) no-repeat center center;\r\n}\r\n\r\n.purple-theme.elevation-control.elevation .area {\r\n  fill: #732C7B;\r\n}\r\n\r\n.purple-theme.elevation-control.elevation .mouse-focus-line {\r\n  stroke: #000;\r\n}\r\n\r\n.purple-theme.height-focus {\r\n  stroke: #000;\r\n  fill: #732C7B;\r\n}\r\n\r\n.purple-theme.elevation-polyline {\r\n  stroke: #732C7B;\r\n}\r\n\r\n/* YELLOW THEME //////////////////////////////////////////////// */\r\n\r\n.yellow-theme.elevation-control.elevation .area {\r\n  fill: #FF0;\r\n}\r\n\r\n.yellow-theme.elevation-polyline {\r\n  stroke: #FF0;\r\n}\r\n\r\n/* RED THEME //////////////////////////////////////////////// */\r\n\r\n.red-theme.elevation-control.elevation .area {\r\n  fill: #F00;\r\n  stroke: #000;\r\n}\r\n\r\n.red-theme.elevation-polyline {\r\n  stroke: #F00;\r\n}\r\n\r\n/* MAGENTA THEME //////////////////////////////////////////////// */\r\n\r\n.magenta-theme.elevation-control.elevation .background {\r\n  background-color: rgba(255, 255, 255, 0.47);\r\n}\r\n\r\n.magenta-theme.elevation-control.elevation .area {\r\n  fill: #FF005E;\r\n  stroke: #000;\r\n}\r\n\r\n.magenta-theme.elevation-polyline {\r\n  stroke: #FF005E;\r\n}\r\n\r\n/* LIGHTBLUE THEME //////////////////////////////////////////////// */\r\n\r\n.lightblue-theme.elevation-control.elevation .area {\r\n  fill: #3366CC;\r\n  stroke: #000;\r\n  stroke-width: 1.25;\r\n}\r\n\r\n.elevation-detached .lightblue-theme.elevation-control.elevation .area {\r\n  stroke: #3366CC;\r\n  fill-opacity: 0.45;\r\n}\r\n\r\n.lightblue-theme.height-focus {\r\n  stroke: #000;\r\n  fill: #FFFFFF;\r\n}\r\n\r\n.lightblue-theme.elevation-polyline {\r\n  stroke: #3366CC;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
